<template>
  <div class="SIM-web">
    <div style="background: rgba(249, 249, 249, 1)" id="header" class="header">
      <div class="flex-box">
        <div class="text-box">
          <p class="head-title">{{ $t("RedteaSIM.title1") }}</p>
          <p class="head-content">{{ $t("RedteaSIM.des1") }}</p>
          <p class="head-content" style="margin-bottom: 0rem">
            {{ $t("RedteaSIM.des2") }}
          </p>
        </div>
        <div class="img-box">
          <video
            :src="videoSrc"
            type="video/mp4"
            width="420"
            controls="controls"
            :poster="poster"
          >
            <p>你的浏览器不支持video标签.</p>
          </video>
        </div>
      </div>
      <a class="more-wrap" href="https://redteasim.com/" target="blank">
        <p class="more">{{ $t("learnMore") }}&nbsp;&nbsp;></p>
      </a>
    </div>
    <div class="flex-box" style="padding: 0.8rem 0" id="cost">
      <div class="img-box">
        <img src="../assets/redteaSIM-web/RedteaSIM 1@2x.png" />
      </div>
      <div class="text-box">
        <p class="title">{{ $t("RedteaSIM.title2") }}</p>
        <div class="line"></div>
        <p class="content con1">{{ $t("RedteaSIM.content1") }}</p>
        <p class="content con2">{{ $t("RedteaSIM.content2") }}</p>
        <p class="content con3">{{ $t("RedteaSIM.content3") }}</p>
      </div>
    </div>
    <div style="width: 11.8rem; margin: auto">
      <Divider />
    </div>

    <div class="flex-box" style="padding: 0.8rem 0" id="Improve">
      <div class="text-box">
        <p class="title">{{ $t("RedteaSIM.title3") }}</p>
        <div class="line"></div>
        <p class="content con4">{{ $t("RedteaSIM.content4") }}</p>
        <p class="content con5">{{ $t("RedteaSIM.content5") }}</p>
        <p class="content con6">{{ $t("RedteaSIM.content6") }}</p>
        <p class="content con7">{{ $t("RedteaSIM.content7") }}</p>
      </div>
      <div class="img-box">
        <img src="../assets/redteaSIM-web/RedteaSIM 2@2x.png" />
      </div>
    </div>
    <div style="width: 11.8rem; margin: auto">
      <Divider />
    </div>

    <div class="flex-box" style="padding: 0.8rem 0" id="exp">
      <div class="img-box">
        <img src="../assets/redteaSIM-web/RedteaSIM 3@2x.png" />
      </div>
      <div class="text-box">
        <p class="title">{{ $t("RedteaSIM.title4") }}</p>
        <div class="line"></div>
        <p class="content con8">{{ $t("RedteaSIM.content8") }}</p>
        <p class="content con9">{{ $t("RedteaSIM.content9") }}</p>
        <p class="content con10">{{ $t("RedteaSIM.content10") }}</p>
        <p class="content con11">{{ $t("RedteaSIM.content11") }}</p>
        <p class="content con12">{{ $t("RedteaSIM.content12") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RedteaGo-web",
  components: {},
  computed: {
    goImg() {
      return this.$store.state.simImg;
    },
    videoSrc() {
      let src = "";
      if (this.$i18n.locale == "zh") {
        src = "https://www.redteamobile.com/RedteaSIM_zh_pc.mp4";
      } else {
        src = "https://www.redteamobile.com/RedteaSIM_en_pc.mp4";
      }
      return src;
    },
    poster() {
      let src = "../assets/logo.png";
      if (this.$i18n.locale == "zh") {
        src = "https://www.redteamobile.com/poster_zh.png";
      } else {
        src = "https://www.redteamobile.com/poster_en.png";
      }
      return src;
    },
  },
};
</script>
<style lang="less" scoped>
.SIM-web {
  video {
    object-fit: cover;
  }
  text-align: left;
  .header {
    padding: 0.8rem;
  }
  .flex-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 12rem;
    margin: auto;
  }
  .text-box {
    width: 5.67rem;
  }
  .img-box {
    img {
      width: 6rem;
    }
  }
  .head-title {
    font-family: "Poppins-Light";
    font-size: 30px;
    margin: 0.8rem 0 0.4rem 0;
  }
  .head-content {
    font-family: "Poppins-Light";
    font-size: 14px;
    margin-bottom: 0.2rem;
  }
  .title {
    font-family: "Poppins-Regular";
    font-size: 20px;
    margin-bottom: 0.2rem;
  }
  .content {
    font-family: "Poppins-Light";
    font-size: 14px;
    margin-bottom: 0.2rem;
    position: relative;
    margin-left: 45px;
  }
  .line {
    width: 100px;
    height: 1px;
    background: rgba(32, 49, 82, 1);
    opacity: 0.3;
    margin: 0.2rem 0;
  }
  .content:before {
    content: "";
    background-size: 35px 35px;
    position: absolute;
    width: 35px;
    height: 35px;
    left: -45px;
    top: 2px;
  }
  .con1:before {
    background-image: url("../assets/redteaSIM-web/1@5x.png");
  }
  .con2:before {
    background-image: url("../assets/redteaSIM-web/2@5x.png");
  }
  .con3:before {
    background-image: url("../assets/redteaSIM-web/3@5x.png");
  }
  .con4:before {
    background-image: url("../assets/redteaSIM-web/4@5x.png");
  }
  .con5:before {
    background-image: url("../assets/redteaSIM-web/5@5x.png");
  }
  .con6:before {
    background-image: url("../assets/redteaSIM-web/6@5x.png");
  }
  .con7:before {
    background-image: url("../assets/redteaSIM-web/7@5x.png");
  }
  .con8:before {
    background-image: url("../assets/redteaSIM-web/8@5x.png");
  }
  .con9:before {
    background-image: url("../assets/redteaSIM-web/9@5x.png");
  }
  .con10:before {
    background-image: url("../assets/redteaSIM-web/10@5x.png");
  }
  .con11:before {
    background-image: url("../assets/redteaSIM-web/11@5x.png");
  }
  .con12:before {
    background-image: url("../assets/redteaSIM-web/12@5x.png");
  }
  .more-wrap {
    display: block;
    width: 12rem;
    margin: 0 auto;
  }
  .more {
    color: rgba(207, 42, 42, 1);
    font-family: "Poppins-Light";
    font-size: 20px;
    text-align: left;
    text-decoration: underline;
    margin-top: 0.4rem;
    // padding-bottom: 1rem;
  }
}
</style>